import HealthLandingPage from './HealthLandingPage';

export default HealthLandingPage;



// WEBPACK FOOTER //
// ./src/components/Pages/Health/HealthLandingPage/index.js